import axiosService from 'services/axios.service';

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const getAllContributorSubscriptionPurchase = async (payload: any): Promise<any> => {
    const response = await axiosService.post(`${BASE_API_URL}/contributor-subscription-purchase`, payload);
    return response?.data?.data;
};

export const getDetailContributorSubscriptionPurchase = async (payload: any): Promise<any> => {
    const response = await axiosService.post(`${BASE_API_URL}/contributor-subscription-purchase/detail`, payload);
    return response?.data;
};

export const getTrackSubscriptionPurchase = async (id: string): Promise<any> => {
    const response = await axiosService.get(`${BASE_API_URL}/contributor-subscription-purchase/${id}`);
    return response?.data;
};
